import React from 'react';
import styled from 'styled-components';
import ReactPlayer from 'react-player/lazy';
import type { ReactPlayerProps } from 'react-player/lazy';
import PlayYoutube from '../../icons/playYoutube';
import Play from '../../icons/play';

const PlayerWrapper = styled.div`
  position: relative;
  padding-bottom: calc(100% / (16 / 9));
`;

interface Props {
  src: string;
  'data-testid'?: string;
  className?: string;
  override?: ReactPlayerProps;
}

export function Player({ src, override = {}, ...otherProps }: Props) {
  return (
    <PlayerWrapper {...otherProps}>
      <ReactPlayer
        light
        playing
        controls
        url={src}
        width="100%"
        height="100%"
        style={{ position: 'absolute' }}
        playIcon={
          src.indexOf('youtu') > 0 ? (
            <PlayYoutube width="12%" height={null} color={null} />
          ) : (
            <Play width="10%" height={null} color="var(--theme-palette-dark-black)" />
          )
        }
        {...override}
      />
    </PlayerWrapper>
  );
}

export default Player;
